import { gql } from '@apollo/client';
import { SH_MATCH_PLAYER_FRAGMENT, ERROR_FRAGMENT } from './fragments.js';

export const SH_PUBLIC_MATCH_FRAGMENT = gql`
  fragment ShPublicMatchFields on _SH_Match {
    id
    clientId
    token
    status
    title
    sportType
    startAt
    endAt
    durationMinutes
    notes
    metadata
    result
    organizer {
      playerId
      name
      firstName
      lastName
      email
      phone
    }
    fieldSnapshot {
      id
      name
      slotDuration
      type
      maxPlayers
      playersPerTeam
      matchPrice
    }
    structureSnapshot {
      id
      name
      address
      city
      cap
    }
    players {
      ...ShMatchPlayerFields
    }
  }
  ${SH_MATCH_PLAYER_FRAGMENT}
`;

export const GET_SH_PUBLIC_MATCH = gql`
  query GetShPublicMatch($token: String!) {
    _SH_publicMatch(token: $token) {
      ok
      match {
        ...ShPublicMatchFields
      }
      error {
        ...ErrorFields
      }
    }
  }
  ${SH_PUBLIC_MATCH_FRAGMENT}
  ${ERROR_FRAGMENT}
`;

export const SH_PUBLIC_PLAYER_PORTAL_LINK_FRAGMENT = gql`
  fragment ShPublicPlayerPortalLinkFields on _SH_PlayerIdentityPlayerLink {
    clientId
    playerId
    preferredStructureId
    linkedAt
    lastAccessAt
  }
`;

export const GET_SH_PUBLIC_PLAYER_PORTAL_ME = gql`
  query GetShPublicPlayerPortalMe($token: String!) {
    _SH_publicPlayerPortalMe(token: $token) {
      ok
      identity {
        id
        email
        phone
        status
        playerLinks {
          ...ShPublicPlayerPortalLinkFields
        }
        createdAt
        updatedAt
      }
      playerLinks {
        ...ShPublicPlayerPortalLinkFields
      }
      originClientId
      originPlayerId
      error {
        ...ErrorFields
      }
    }
  }
  ${SH_PUBLIC_PLAYER_PORTAL_LINK_FRAGMENT}
  ${ERROR_FRAGMENT}
`;

export const GET_SH_PUBLIC_STRUCTURE = gql`
  query GetShPublicStructure($companyname: String!, $structureId: ID!) {
    _SH_publicStructure(companyname: $companyname, structureId: $structureId) {
      ok
      features {
        availabilityRequestsEnabled
      }
      structure {
        id
        name
        description
        address
        city
        province
        cap
        phone
        email
        openingTime
        closingTime
        media {
          immagine_primaria
          img_secon
          logo
          gallery
          images {
            id
            filename
            url
            tags
            label
            description
            order
          }
          views {
            id
            name
            description
            tags
            layout
            order
          }
        }
      }
      fields {
        id
        name
        description
        type
        slotDuration
        timeSlotLession
        openingTime
        closingTime
        slotStrategy
        slotStep
        maxPlayers
        playersPerTeam
        matchPrice
      }
      error {
        ...ErrorFields
      }
    }
  }
  ${ERROR_FRAGMENT}
`;

export const UPDATE_SH_PUBLIC_MATCH_RESULT = gql`
  mutation UpdateShPublicMatchResult($token: String!, $input: _SH_UpdateMatchResultInput!) {
    _SH_updatePublicMatchResult(token: $token, input: $input) {
      ok
      error {
        ...ErrorFields
      }
      match {
        ...ShPublicMatchFields
      }
    }
  }
  ${SH_PUBLIC_MATCH_FRAGMENT}
  ${ERROR_FRAGMENT}
`;

export const REQUEST_SH_PUBLIC_MATCH_EDIT_LINK = gql`
  mutation RequestShPublicMatchEditLink(
    $token: String!
    $email: String!
    $firstName: String
    $lastName: String
  ) {
    _SH_requestPublicMatchEditLink(
      token: $token
      email: $email
      firstName: $firstName
      lastName: $lastName
    ) {
      ok
      error {
        ...ErrorFields
      }
    }
  }
  ${ERROR_FRAGMENT}
`;

export const OPEN_SH_MY_PORTAL = gql`
  mutation OpenShMyPortal($matchToken: String!) {
    _SH_openMyPortal(matchToken: $matchToken) {
      ok
      portalToken
      error {
        ...ErrorFields
      }
    }
  }
  ${ERROR_FRAGMENT}
`;

export const OPEN_SH_MATCH_FROM_PORTAL = gql`
  mutation OpenShMatchFromPortal($token: String!, $matchToken: String!) {
    _SH_openMatchFromPortal(token: $token, matchToken: $matchToken) {
      ok
      matchAccessToken
      matchToken
      error {
        ...ErrorFields
      }
    }
  }
  ${ERROR_FRAGMENT}
`;

export const GET_SH_PUBLIC_PLAYER_MATCHES = gql`
  query GetShPublicPlayerMatches($clientId: ID!, $playerId: ID!, $limit: Int) {
    _SH_publicPlayerMatches(clientId: $clientId, playerId: $playerId, limit: $limit) {
      ok
      matches {
        ...ShPublicMatchFields
      }
      error {
        ...ErrorFields
      }
    }
  }
  ${SH_PUBLIC_MATCH_FRAGMENT}
  ${ERROR_FRAGMENT}
`;
